import { SchedulePanel } from '../../components/SchedulePanel'

/**
 * Unattended runs, and the time zone their crons are read in.
 *
 * @remarks
 * <para>
 * A wrapper, not a rewrite: the same panel that used to sit at the bottom of the Run
 * Console, rendered under the configuration path instead. It was reachable there and
 * nobody would think to look for it there — a run console is where you watch runs, not
 * where you expect to define when they happen.
 * </para>
 * <para>
 * The time zone stays inside the panel rather than moving to a general organization page.
 * A cron expression is meaningless without the zone it is interpreted in, and separating
 * the two would mean reading one screen to understand the other.
 * </para>
 */
export function ScheduleSettings() {
  return <SchedulePanel />
}
